import React, { Component } from 'react'
import Footer from '../../Component/Footer'
import Header from '../../Component/Header'
import Menu from '../../Component/Menu'
import NewService from './NewServices'

export default class NewItemWrapper extends Component {
  render() {
    return (
      <div>
        <Header />
        <Menu/>
        <div className="content-wrapper">
          <NewService {...this.props} />
        </div>
        <Footer/>
      </div>
    )
  }
}